<template>
  <div class="tableOfContents-wrapper">
    <app-header></app-header>
    <div class="tableOfContents">
      <h1 class="tableOfContents-h1">Table of contents</h1>
      <div class="tableOfContents_border"></div>
      <img class="tableOfContents-img" src="@/assets/png/table.png"/>
      <p class="tableOfContents-p">You are most welcome to our all-new HOSA Website where you can learn about living and enjoying your residence at the Regimanuel Gray Estates, East Airport, Accra, Ghana.
      Our unique estate is the flagship of the developer, Regimanuel Gray Limited. It is quietly nestled off the Spintex Road in Accra, Ghana. It is a haven of beauty, peace, tranquillity, safety, comfort and security.
      Our estate comprises 6 completed gates pending the last development of luxury apartments by the developer. Within easy reach of the development are schools, shops and a church; as well as two shopping malls one at each end of the Spintex Road and all the shops and businesses along the Spintex Road.
      Living on the estate is the epitome of all the benefits of living on a managed estate. Our estate is the first truly managed estate in Ghana, ably managed by the RG Estate Management Company. With neat streets, well -manicured lawns and a uniform colour scheme which lends a serene character to the estate, Regimanuel Gray Estates – East Airport is one of the most sought-after residential addresses in Ghana.
      We encourage you to visit the website regularly for news and updates on events on the estate.
      Use your special access code to access forms and news on HOSA .You are most welcome to our all-new HOSA Website where you can learn about living and enjoying your residence at the Regimanuel Gray Estates, East Airport, Accra, Ghana.
      Our unique estate is the flagship of the developer, Regimanuel Gray Limited. It is quietly nestled off the Spintex Road in Accra, Ghana. It is a haven of beauty, peace, tranquillity, safety, comfort and security.
      Our estate comprises 6 completed gates pending the last development of luxury apartments by the developer. Within easy reach of the development are schools, shops and a church; as well as two shopping malls one at each end of the Spintex Road and all the shops and businesses along the Spintex Road.
      Living on the estate is the epitome of all the benefits of living on a managed estate. Our estate is the first truly managed estate in Ghana, ably managed by the RG Estate Management Company. With neat streets, well -manicured lawns and a uniform colour scheme which lends a serene character to the estate, Regimanuel Gray Estates – East Airport is one of the most sought-after residential addresses in Ghana.
      We encourage you to visit the website regularly for news and updates on events on the estate.
      Use your special access code to access forms and news on HOSA .</p>
    </div>
    <app-contact></app-contact>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import ContactUs from '@/components/ui/ContactUs'
export default {
  components: {
    'app-header': Header,
    'app-footer': Footer,
    'app-contact': ContactUs,
  }
}
</script>

<style lang="scss" scoped>
.tableOfContents {
  margin: 100px auto 109px auto;
  position: relative;
  max-width: 1200px;
  @media screen and (max-width: 1200px) {
    padding: 0 5px;
  }
  &-wrapper {
    width: 100%;
    background-color: #ffffff;
  }
  &-h1 {
    color: #38383a;
    font-family: "Optimal C";
    font-size: 30px;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.07px;
  }
  &_border {
    width: 63px;
    height: 3px;
    background-color: #2a9854;
    margin-bottom: 46px;
  }
  &-img {
    max-width: 1200px;
    width:100%;
    margin-bottom: 61px;
  }
  &-p {
    color: #424244;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0.35px;
    margin: 0 3px;
  }
}
</style>